import { useState } from 'react';
import { useUserState } from '../../hooks/context/useUserState';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { updateDatasetData } from '../requests/dataset/updateDatasetData';

export const useUpdateDatasetData = () => {
  const {
    state: { token },
  } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [response, setResponse] = useState<any>(undefined);

  const update = async (api: string, data: any, forceHeader?: string) => {
    let res;
    try {
      setIsLoading(true);
      setResponse(undefined);
      setError(undefined);
      res = await updateDatasetData(api, data, token, forceHeader);
      setResponse(res);

      return {
        response: res,
        error: null,
      };
    } catch (e) {
      if (e instanceof Error) setError(e);
      const errorHandlingRes = await handleApiError(e, false, (forceHeader) =>
        update(api, data, forceHeader)
      );
      if (errorHandlingRes instanceof Error) {
        return {
          response: null,
          error: errorHandlingRes,
        };
      }
      return errorHandlingRes;
    } finally {
      setIsLoading(false);
    }
  };

  const handleApiError = useApiErrorHandling();
  return {
    isLoading,
    error,
    response,
    update,
  };
};
